import React from "react";
import AdminCompanies from "./admin-companies";
import CreateCompany from "./create-company/create-company";

class AdminCompaniesController extends React.Component{

    getCompanyIdByRole = (props) => {
        if(props.role){
            if(props.role === 'ROLE_SUPER_ADMIN'){
                if(props.adminCompanyId){
                    return props.adminCompanyId
                }
                else if(props.companyId){
                    return props.companyId;
                }
                else{
                    return null;
                }
            }
            else if(props.role === 'ROLE_ADMIN')
                return props.adminCompanyId
        }
        else return null

    }

    constructor(props){
        super(props);
        this.state = {
            companyId: this.getCompanyIdByRole(this.props),
            topicId: this.props.topicId,
            accountId: this.props.accountId,
            role: this.props.role,
            currentPage: this.props.currentPage,
            showedItemsCount: this.props.showedItemsCount,
            sortBy: 'CREATED_AT',
            sortDirection: 'DESC',
            status: "ACTIVE",
            search: null,
            isUpdated: false,
            deletedPageIndex: 0,
            deletedPageSize: 10
        }
    }

    CreateComapany = (name, bin, maxNumTopics) => {
        this.props.createCompany(name, bin, maxNumTopics)
    }

    editCompany = (companyId, companyName, companyBin, companyTopicsCount, companyStatus) => {
        this.props.updateCompany(companyId, companyName, companyBin, companyTopicsCount, companyStatus)
    }

    closeRightMenu = () => {        
        this.props.setShowRightMenu(false);
        this.props.setRightMenuComponent(null);
        this.props.setRemoveRightMenuComponent();
    }

    setSortBy = (sortBy, sortDirection, status) => {
        
        this.setState({
            sortBy: sortBy,
            sortDirection: sortDirection,
            status: status,
            isUpdated: true
        })
        this.getCompanies(sortBy, sortDirection, status);
    }

    setSortByStatus = (status) => {
        this.setState({
            status: status,
            isUpdated: true,
        })
        this.props.setCurrentPage(0)
        this.getCompanies(null, null, status);
    }

    setSortDirection = (sortDirection) => {
        this.setState({
            sortDirection: sortDirection
        })
        this.getCompanies(null, sortDirection);
    }

    setSearch = (search) => {
        this.setState({
            search: search
        })
    }

    search = (searchText) => {
        this.getCompanies(null, null, null, searchText);
    }

    getCompanies = (sortBy=null, sortDirection=null, status=null, search=null) => {
        let sortField = sortBy ? sortBy : this.state.sortBy;
        let sortByDirection = sortDirection ? sortDirection : this.state.sortDirection;
        let sortByStatus = status ? status : this.state.status;
        let searchText = search !== null ? search : this.state.search;
        this.props.getSuperadminCompanies('ALL', this.props.currentPage, this.props.showedItemsCount, null, null, sortField, sortByDirection, sortByStatus, searchText);
    }

    componentDidMount(){
        this.props.isSuperadmin && this.getCompanies()
        if(this.state.companyId){
            this.props.getCompanyAccounts(this.state.companyId, this.props.isSuperadmin);
            this.props.getCompanyTopics(this.state.companyId, this.props.isSuperadmin);
            this.props.getCompanyDeletedTopics(this.state.companyId, this.props.isSuperadmin, this.state.deletedPageIndex, this.state.deletedPageSize)
        }
        
    }

    /*checkCompanyId = () => {
        if(this.props.isSuperadmin){
            if(this.props.adminCompanyId){
                this.props.adminCompanyId !== this.state.companyId
            }
            else{
                return this.props.companyId !== this.state.companyId
            }
        }
        else
            return this.props.adminCompanyId !== this.state.companyId
    }*/

    getAccountById = (accountId) => {
        return this.props.accounts ? this.props.accounts.find(k => k.id === accountId) : null
    }


    componentDidUpdate(prevProps, prevState){
        if(this.props.isSuperadmin && !this.props.isFetching){
            if(this.props.currentPage > (this.props.itemsCount / this.props.showedItemsCount)){
                this.props.setCurrentPage(0)
                this.getCompanies();
            }
            if (
                !this.props.companies ||
                this.props.currentPage !== this.state.currentPage ||
                this.props.showedItemsCount !== this.state.showedItemsCount
            ){ 
                this.getCompanies();
                this.props.getMarkers();
                
                if(this.props.currentPage !== this.state.currentPage || this.props.showedItemsCount !== this.state.showedItemsCount){
                    this.closeRightMenu();
                    this.props.setCompanyId(null)
                    //this.props.setTopicId(null)
                    this.setState({
                        companyId: null,
                        currentPage: this.props.currentPage,
                        showedItemsCount: this.props.showedItemsCount
                        //showedItemsCount: this.props.showedItemsCount
                    })
                }
            }
            if(this.props.companies && this.props.itemsCount !== this.props.companiesCount){
                this.props.setItemsCount(Number(this.props.companiesCount) && this.props.companiesCount)
            }
        }
        if(this.getCompanyIdByRole(this.props) && this.getCompanyIdByRole(this.props) !== this.state.companyId ){
            this.setState({
                deletedPageIndex: 0,
                deletedPageSize: 10
            })
            this.props.getCompanyDeletedTopics(this.getCompanyIdByRole(this.props), this.props.isSuperadmin, 0, 10);
        }
        if( (this.getCompanyIdByRole(this.props) && this.getCompanyIdByRole(this.props) !== this.state.companyId )|| this.props.topicId !== this.state.topicId || this.props.accountId !== this.state.accountId){ 
            let companyId = this.getCompanyIdByRole(this.props)
            this.setState({
                companyId: companyId,
                topicId: this.props.topicId,
                accountId: this.props.accountId,
                role: this.props.role,
            })
            if(this.props.topicId){
                if(companyId)
                    this.props.getTopicAccounts(companyId, this.props.topicId, this.props.isSuperadmin)
            }

            if(this.props.accountId){
                let account = this.getAccountById(this.props.accountId);
                if(account && account.role && account.role === 'ROLE_MARKER'){
                    this.props.getMarkerTopics(this.props.accountId)
                }
                else{
                    this.props.getAccountTopics(companyId, this.props.accountId, this.props.isSuperadmin)
                }
            }
            if(companyId){
                this.props.getCompanyAccounts(companyId, this.props.isSuperadmin);
                this.props.getCompanyTopics(companyId, this.props.isSuperadmin);
                
            }
        
        }
        
        if (this.props.topicId !== prevProps.topicId) {
            let companyId = this.getCompanyIdByRole(this.props)
            if (companyId && this.props.topicId) {
                this.props.getTopicAccounts(companyId, this.props.topicId, this.props.isSuperadmin)
            }
        }

        /*if(this.props.role === 'ROLE_ADMIN'){
            this.props.getCompany()
        }*/

        if (this.props.role !== prevProps.role && this.props.role === 'ROLE_ADMIN') {
            this.props.getCompany()
        }

        /*if(this.state.isUpdated){
            this.setState({
                isUpdated: false
            })
        }*/

        if (this.state.isUpdated && this.state.isUpdated !== prevState.isUpdated) {
            this.setState({ isUpdated: false })
        }
    }

    setPage = (page) => {
        this.setState({
            deletedPageIndex: page
        });
        this.props.getCompanyDeletedTopics(this.state.companyId, this.props.isSuperadmin, page, this.state.deletedPageSize);
    }

    setShowedCount = (count) => {
        this.props.getCompanyDeletedTopics(this.state.companyId, this.props.isSuperadmin, 0, count);
        this.setState({
            deletedPageSize: count,
            deletedPageIndex: 0
        });
    }

    render(){
        return (
                !this.props.isFetching && <AdminCompanies 
                                getValue={this.props.getValue}
                                companies={this.props.companies}
                                companyId={this.getCompanyIdByRole(this.props)} 
                                topics={this.props.topics}
                                accounts={this.props.accounts}
                                topicId={this.props.topicId}
                                accountId={this.props.accountId}
                                role={this.props.role}
                                showRightMenu={this.showRightMenu}
                                isSuperadmin={this.props.isSuperadmin}
                                companyName={this.props.companyName}
                                adminCompanyId={this.props.adminCompanyId}
                                selectedLanguage={this.props.selectedLanguage}
                                sortBy={this.state.sortBy}
                                sortDirection={this.state.sortDirection}
                                setSortBy={this.setSortBy}
                                setSortDirection={this.setSortDirection}
                                status={this.state.status}
                                setSortByStatus={this.setSortByStatus}
                                searchText={this.state.search}
                                searchByText={this.search}
                                setSearch={this.setSearch}
                                companyDeletedTopicsCount={this.props.companyDeletedTopicsCount}
                                showedItemsCount={this.state.deletedPageSize}
                                currentPage={this.state.deletedPageIndex}
                                setPage={this.setPage}
                                setShowedCount={this.setShowedCount}
                                />
        )
    }
shouldComponentUpdate(nextProps, nextState){
    if(!nextProps.isFetching){
        return true;
    }
    else return false
}

    componentWillUnmount(){
        this.closeRightMenu()
        /*this.props.setItemsCount(null)
        this.props.setCurrentPage(0)
        this.props.setShowedItemsCount(10)*/
        this.props.setCompanyId(null)
        this.props.setToDefaultPaginator();
    }
}

export default AdminCompaniesController;